import type { CandidateOtpChallenge } from "@/lib/api";

const OTP_STORAGE_KEY = "gupio_portal_pending_otp";

export function clearPendingOtpChallenge() {
  window.sessionStorage.removeItem(OTP_STORAGE_KEY);
}

export function readPendingOtpChallenge() {
  const raw = window.sessionStorage.getItem(OTP_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as CandidateOtpChallenge;
  } catch {
    clearPendingOtpChallenge();
    return null;
  }
}

export function savePendingOtpChallenge(challenge: CandidateOtpChallenge) {
  window.sessionStorage.setItem(OTP_STORAGE_KEY, JSON.stringify(challenge));
}
